module.exports = __webpack_public_path__ + "img/swt_branner.cf7c1cd.jpg";